import { BackButton } from '@library/buttons';
import { PageHeading, PageTemplate } from 'modules/shared/features/content';
import AddSiteRecceForm from 'modules/site-recce/components/AddSiteRecceForm/AddSiteRecceForm';

const AddSiteReccePage = () => {
    return (
        <PageTemplate>
            {/* <BackButton /> */}
            <PageHeading>
                <div className="flex gap-2">Add Site Recce</div>
            </PageHeading>

            <AddSiteRecceForm />
        </PageTemplate>
    );
};

export default AddSiteReccePage;
